/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { catchError, tap } from "rxjs/operators";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { GeoCodeService } from "./services/common/geocode/geo-code.service";
import { DivisionService } from "./services/division/division.service";
import { LocalStorageService } from "./services/shared/local-storage/local-storage.service";
import { RegexService } from "./services/shared/regex/regex.service";

@Injectable()
export class Interceptor implements HttpInterceptor {
  constructor(
    private toastrService: ToastrService,
    private router: Router,
    public geoCodeService: GeoCodeService,
    public divisionService: DivisionService,
    public localStorageService: LocalStorageService,
    public regexService: RegexService
  ) {}
  skipUrlsForRedirection = (urls: string[]): boolean => {
    const navigationUrl = this.router?.routerState.snapshot.url;
    return (
      navigationUrl &&
      urls.some((url) => navigationUrl.toLocaleLowerCase().includes(url))
    );
  };
  // function which will be called for all http calls
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // how to update the request Parameters
    const emailList = [
      "username",
      "email",
      "userName",
      "emails",
      "consumerEmail",
    ];
    console.log(JSON.stringify(request));
    if (request.body) {
      Object.keys(request.body).forEach((key) => {
        if (
          key === "emails" ||
          (key === "businessUnit" &&
            request.body[key]?.emails?.length &&
            request?.url?.includes("branches"))
        ) {
          for (const eachEmail of key === "emails"
            ? request?.body[key]
            : request?.body[key]?.emails) {
            if (this.regexService.getEmailRegex().test(eachEmail?.email)) {
              eachEmail.email = eachEmail?.email?.toLowerCase();
            }
          }
        } else if (
          emailList.includes(key) &&
          this.regexService.getEmailRegex().test(request?.body[key])
        ) {
          request.body[key] = request?.body[key].toLowerCase();
        }
      });
    }
    const mail = request.params.get("mailID");
    if (mail) {
      request = request.clone({
        setParams: {
          mailID: mail.toLowerCase(),
        },
      });
    }
    const email = request.params.get("email");
    if (email) {
      request = request.clone({
        setParams: {
          email: email.toLowerCase(),
        },
      });
    }
    if (
      localStorage.getItem("nVipaniwhiteshopkey") &&
      localStorage.getItem("nVipaniwhiteshopkey") !== undefined
    ) {
      const updatedRequest = request.clone({
        headers: request.headers.set(
          "Authorization",
          localStorage.getItem("nVipaniwhiteshopkey")
        ),
      });
      // logging the updated Parameters to browser's console
      return next.handle(updatedRequest).pipe(
        catchError((error: HttpErrorResponse & { urgent?: boolean }) => {
          if (
            error.error.message === "Session Expired." &&
            !this.geoCodeService.sessionCount &&
            !this.skipUrlsForRedirection(["liveshop"])
          ) {
            this.toastrService.info(
              "Session expired. Please login again",
              null,
              {
                timeOut: 2000,
              }
            );
            let companyConfig = localStorage.getItem("companyConfig");
            let config = localStorage.getItem("config");
            let currentBusinessUnit = sessionStorage.getItem(
              "currentBusinessUnit"
            );
            let c2cKey;
            if (localStorage.getItem("c2cKey")) {
              c2cKey = localStorage.getItem("c2cKey");
            }
            this.localStorageService.resetUserData();
            if (companyConfig) {
              localStorage.setItem("companyConfig", companyConfig);
            }
            if (config) {
              localStorage.setItem("config", config);
            }
            if (currentBusinessUnit) {
              sessionStorage.setItem(
                "currentBusinessUnit",
                currentBusinessUnit
              );
            }
            const url = new URL(window.location.href);
            const params = url.searchParams;
            if (
              !(
                window.location.href.includes("orderLinkCode") ||
                window.location.href.includes("target")
              ) &&
              !c2cKey
            ) {
              this.router.navigate(["/"]);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else if (
              window.location.href.includes("orderLinkCode") &&
              window.location.href.includes("isEmbedded") &&
              params.get("isEmbedded")
            ) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            this.divisionService.sessionTimeOut.next(
              this.divisionService.sessionValue
            );
            this.geoCodeService.sessionCount++;
          }
          error.urgent = true;
          return throwError(error);
        })
      );
    } else if (
      localStorage.getItem("retailerToken") &&
      localStorage.getItem("retailerToken") !== undefined
    ) {
      const updatedRequest = request.clone({
        headers: request.headers.set(
          "Authorization",
          localStorage.getItem("retailerToken")
        ),
      });
      return next.handle(updatedRequest).pipe(
        catchError((error: HttpErrorResponse & { urgent?: boolean }) => {
          if (
            error.error.message === "Session Expired." &&
            !this.geoCodeService.sessionCount &&
            !this.skipUrlsForRedirection(["liveshop"])
          ) {
            this.toastrService.info(
              "Session expired. Please login again",
              null,
              {
                timeOut: 2000,
              }
            );
            let companyConfig = localStorage.getItem("companyConfig");
            let config = localStorage.getItem("config");
            let c2cKey;
            if (localStorage.getItem("c2cKey")) {
              c2cKey = localStorage.getItem("c2cKey");
            }
            let currentBusinessUnit;
            if (sessionStorage.getItem("currentBusinessUnit")) {
              currentBusinessUnit = sessionStorage.getItem(
                "currentBusinessUnit"
              );
            }
            if (
              !(
                window.location.href.includes("orderLinkCode") ||
                window.location.href.includes("target")
              ) &&
              !c2cKey
            ) {
              this.router.navigate(["/"]);
            }
            this.localStorageService.resetUserData();
            if (companyConfig) {
              localStorage.setItem("companyConfig", companyConfig);
            }
            if (config) {
              localStorage.setItem("config", config);
            }
            if (
              currentBusinessUnit &&
              Object.keys(currentBusinessUnit).length
            ) {
              sessionStorage.setItem(
                "currentBusinessUnit",
                currentBusinessUnit
              );
            }
            this.geoCodeService.sessionCount++;
          }
          error.urgent = true;
          return throwError(error);
        })
      );
    } else if (!localStorage.getItem("retailerToken")) {
      let headers = new HttpHeaders();

      if (request.url.toLowerCase().includes("getvideocall")) {
        // disabling disk cache
        headers = headers.set("Cache-Control", "no-cache");
        headers = headers.set("Pragma", "no-cache");
        headers = headers.set("Expires", "0");
      }

      const updatedRequest = request.clone({ headers });

      return next.handle(updatedRequest).pipe(
        catchError((error: HttpErrorResponse & { urgent?: boolean }) => {
          if (!error.error.message || error.error.message === "No Data") {
            if (
              !(
                window.location.href.includes("orderLinkCode") ||
                window.location.href.includes("target")
              ) &&
              !localStorage.getItem("c2cKey")
            ) {
              this.router.navigateByUrl("/");
            }
          }
          error.urgent = true;
          return throwError(error);
        })
      );
    } else {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse & { urgent?: boolean }) => {
          error.urgent = true;
          return throwError(error);
        })
      );
    }
  }
}
